var _path, _path2, _path3, _path4, _rect, _path5, _path6, _path7, _path8, _g, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _g2, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _g3, _path42, _path43, _path44, _g4, _path45, _path46, _path47, _g5, _path48, _path49, _path50, _g6, _path51, _path52, _path53, _g7, _path54, _path55, _path56, _g8, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _g9, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _g10, _path86, _path87, _path88, _path89, _g11, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoleImgDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 657,
    height: 859,
    viewBox: "0 0 657 859",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172.24 -0.5L713.24 0L712.74 859H74.2402L172.24 -0.5Z",
    fill: "#4F4557"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M74 860.5L131.5 358L577.143 359.267C613.838 359.372 637.924 397.652 622.137 430.777L486.416 715.57C480.416 728.16 469.43 737.672 456.111 741.809L74 860.5Z",
    fill: "#393646"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.478 895.196C62.2338 877.138 62.8167 821.165 102.429 803.927L589.259 592.08C621.601 578.006 657.957 600.943 659.179 636.194L666.544 848.544C667.493 875.918 646.24 898.961 618.878 900.223L170.704 920.898C162.719 921.267 154.761 919.715 147.499 916.373L101.478 895.196Z",
    fill: "#6D5D6E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M317.817 889.927C310.512 889.314 306.327 881.31 309.993 874.962L387.739 740.301C401.546 716.387 432.126 708.193 456.04 722L656.082 837.494C662.689 841.309 662.762 850.819 656.215 854.736L576.811 902.238C567.83 907.61 557.39 910.029 546.961 909.154L317.817 889.927Z",
    fill: "#162F15"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 410.156,
    y: 139.961,
    width: 391.48,
    height: 387.982,
    rx: 50,
    transform: "rotate(-91.7219 410.156 139.961)",
    fill: "#162F15"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4618 42.9056C46.5567 9.59822 71.9704 -26.8721 108.032 -25.3609L710.138 -0.128726C711.872 -0.0560956 713.239 1.3701 713.239 3.10479C713.239 4.75376 711.999 6.13909 710.361 6.32131L111.417 72.918C89.652 75.338 68.8985 63.1143 60.4618 42.9056Z",
    fill: "#6D5D6E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M514.282 259.702C514.282 259.702 472.591 225.651 418.368 240.749C364.145 255.848 341.456 302.555 310.349 334.666C294.063 351.486 270.003 357.689 250.658 370.614C188.836 412.021 197.957 505.076 245.684 540.188C286.982 570.576 338.589 573.753 405.736 551.34C472.884 528.927 520.945 515.459 562.595 451.263C604.244 387.066 565.638 305.907 514.282 259.702Z",
    fill: "#FE8225"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M514.282 259.702C514.282 259.702 472.591 225.651 418.368 240.749C364.145 255.848 341.456 302.555 310.349 334.666C294.063 351.486 270.003 357.689 250.658 370.614C188.836 412.021 197.957 505.076 245.684 540.188C286.982 570.576 338.589 573.753 405.736 551.34C472.884 528.927 520.945 515.459 562.595 451.263C604.244 387.066 565.638 305.907 514.282 259.702Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5082_4301",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 209,
    y: 336,
    width: 86,
    height: 140
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M233.98 474.378V444.449C233.98 444.449 237.7 432.419 243.41 431.174L249.112 429.936L294.456 430.129V336.923H209.627V475.423L233.98 474.378Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5082_4301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.584 355.892C266.584 355.892 266.584 352.18 261.384 346.989C256.184 341.797 252.857 338.821 252.857 338.821C252.857 338.821 250.257 347.356 255.081 352.556C258.629 356.215 262.477 359.571 266.584 362.588V355.892Z",
    fill: "#FE8225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.001 379.066C259.001 379.066 259.001 375.354 253.81 370.162C248.618 364.971 245.274 361.995 245.274 361.995C245.274 361.995 242.674 370.53 247.498 375.722C251.045 379.382 254.893 382.738 259.001 385.754V379.066Z",
    fill: "#FE8225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.216 362.212C266.216 362.212 266.609 358.525 272.319 353.902C278.029 349.279 281.632 346.688 281.632 346.688C281.632 346.688 283.304 355.449 277.97 360.105C274.043 363.367 269.849 366.293 265.43 368.85L266.216 362.212Z",
    fill: "#FE8225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.104 389.574C257.104 389.574 257.881 385.946 264.051 381.958C270.221 377.971 274.083 375.764 274.083 375.764C274.083 375.764 274.835 384.65 269.067 388.722C264.824 391.554 260.349 394.024 255.691 396.104L257.104 389.574Z",
    fill: "#FE8225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.818 419.411C258.818 419.411 258.818 415.7 264.017 410.508C269.217 405.316 272.545 402.349 272.545 402.349C272.545 402.349 275.145 410.876 270.321 416.076C266.773 419.735 262.925 423.09 258.818 426.108V419.411Z",
    fill: "#FE8225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.734 426.693C258.734 426.693 259.261 423.023 254.855 417.145C250.449 411.268 247.573 407.849 247.573 407.849C247.573 407.849 243.786 415.925 247.824 421.752C250.817 425.873 254.147 429.737 257.781 433.305L258.734 426.693Z",
    fill: "#FE8225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.609 448.278C253.609 448.278 253.609 444.566 258.801 439.375C263.992 434.183 267.336 431.207 267.336 431.207C267.336 431.207 269.936 439.743 265.113 444.934C261.566 448.594 257.718 451.95 253.609 454.966V448.278Z",
    fill: "#FE8225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.079 467.841C257.079 467.841 256.142 464.254 259.846 457.917C263.549 451.58 266.041 447.885 266.041 447.885C266.041 447.885 270.714 455.476 267.361 461.729C264.854 466.162 261.979 470.376 258.767 474.328L257.079 467.841Z",
    fill: "#FE8225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.01 354.939C266.75 358.802 266.275 362.648 265.589 366.459C263.533 377.068 258.4 383.915 256.393 393.495C254.387 403.076 260.23 415.424 258.65 427.729C257.07 440.035 252.28 446.882 253.634 455.092C254.989 463.301 262.404 486.015 262.404 486.015",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.166 364.678L271.759 360.381",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.425 359.729L264.076 355.566",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.661 393.052C256.661 393.052 261.342 389.533 266.166 386.021",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.001 385.746C259.001 385.746 255.097 378.088 250.7 372.988",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.001 424.687C261.681 419.766 265.06 415.261 269.033 411.311",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.09 429.894C256.669 426.549 254.971 423.328 253.016 420.264C250.282 416.226 249.864 415.708 249.864 415.708",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.609 455.092C254.784 452.147 256.182 449.297 257.789 446.564C259.41 444.029 261.239 441.633 263.257 439.4",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.767 474.303C258.5 471.487 258.984 468.651 260.172 466.085C262.128 462.315 264.352 457.365 265.255 455.409",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.149 405.458C224.149 405.458 223.747 403.134 226.439 399.314C229.131 395.493 230.904 393.27 230.904 393.27C230.904 393.27 233.462 398.336 231.004 402.114C229.172 404.787 227.123 407.304 224.876 409.638L224.149 405.458Z",
    fill: "#FE8225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.397 419.169C231.397 419.169 230.995 416.845 233.687 413.024C236.379 409.204 238.16 406.98 238.16 406.98C238.16 406.98 240.668 412.046 238.252 415.825C236.426 418.502 234.376 421.019 232.124 423.349L231.397 419.169Z",
    fill: "#FE8225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.043 409.388C225.043 409.388 224.399 407.114 220.311 404.84C216.223 402.566 213.665 401.329 213.665 401.329C213.665 401.329 213.565 407.005 217.419 409.346C220.228 410.965 223.167 412.346 226.205 413.476L225.043 409.388Z",
    fill: "#FE8225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.721 425.556C233.721 425.556 232.885 423.365 228.538 421.534C224.19 419.704 221.565 418.742 221.565 418.742C221.565 418.742 222.059 424.394 226.138 426.316C229.109 427.634 232.185 428.699 235.334 429.502L233.721 425.556Z",
    fill: "#FE8225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.886 444.449C235.886 444.449 235.485 442.125 231.664 439.433C227.844 436.741 225.428 435.253 225.428 435.253C225.428 435.253 224.725 440.888 228.312 443.613C230.935 445.513 233.712 447.19 236.613 448.629L235.886 444.449Z",
    fill: "#FE8225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.73 449.006C236.73 449.006 236.003 446.765 238.127 442.602C240.25 438.439 241.688 435.981 241.688 435.981C241.688 435.981 244.94 440.637 243.042 444.726C241.61 447.649 239.932 450.446 238.026 453.086L236.73 449.006Z",
    fill: "#FE8225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.251 467.774C243.251 467.774 243.527 465.433 247.18 462.524C250.834 459.615 253.208 457.984 253.208 457.984C253.208 457.984 254.228 463.569 250.8 466.503C248.292 468.555 245.616 470.393 242.8 471.996L243.251 467.774Z",
    fill: "#FE8225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.29 461.988C242.29 461.988 241.889 459.664 238.11 456.972C234.331 454.281 231.873 452.792 231.873 452.792C231.873 452.792 231.171 458.427 234.757 461.152C237.379 463.054 240.156 464.732 243.059 466.168L242.29 461.988Z",
    fill: "#FE8225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.24 474.638C242.24 474.638 242.44 472.28 239.422 468.71C236.404 465.141 234.448 463.076 234.448 463.076C234.448 463.076 232.341 468.342 235.125 471.895C237.178 474.405 239.437 476.737 241.88 478.868L242.24 474.638Z",
    fill: "#FE8225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.756 404.915C224.338 407.307 225.053 409.666 225.896 411.979C228.337 418.416 232.3 422.145 234.624 427.93C236.948 433.715 234.624 442.142 236.923 449.666C239.222 457.19 242.992 460.977 243.026 466.277C243.059 471.578 241.119 485.915 241.119 485.915",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.344 410.926L221.365 408.844",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.642 407.849L225.662 404.982",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.381 427.688C234.381 427.688 231.037 426.016 227.693 424.344",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.116 423.357C233.093 420.272 234.381 417.294 235.961 414.47",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.346 447.785C234.135 444.981 231.527 442.514 228.605 440.462",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.483 450.945C238.011 448.694 238.727 446.49 239.623 444.358C240.894 441.532 241.086 441.164 241.086 441.164",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.85 470.282C244.141 468.68 245.57 467.194 247.122 465.843C248.113 465.114 249.044 464.306 249.906 463.427",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.026 466.26C241.963 464.541 240.769 462.906 239.456 461.37C238.172 459.959 236.774 458.656 235.276 457.474",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.88 478.868C241.745 477.068 241.133 475.337 240.108 473.852C238.436 471.695 236.547 468.836 235.761 467.707",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M565.864 304.252H506.717V381.708H565.864V304.252Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M556.726 316.215H515.862V369.728H556.726V316.215Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M476.913 276.087H430.674V336.639H476.913V276.087Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M469.774 285.442H437.822V327.276H469.774V285.442Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M245.049 576.387L242.34 584.772H539.956L538.05 576.821L245.049 576.387Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M545.624 478.65C545.808 464.095 546 456.789 546 450.769C546 432.076 529.28 429.936 529.28 429.936H249.103C249.103 429.936 234.423 428.331 234.423 449.833C234.423 457.541 233.863 466.754 234.197 479.093",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M267.779 504.198H512.527",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M234.423 524.914V541.986C234.423 543.538 235.04 545.026 236.137 546.124C237.235 547.221 238.723 547.838 240.275 547.838H337.753V523.092C337.753 514.356 338.396 504.106 338.396 504.106V439.985C338.396 439.985 337.402 434.376 339.232 430.639",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M337.794 547.871H452.82L453.547 504.198V440.486C453.547 440.486 453.355 434.409 451.039 430.204",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M452.82 547.871H540.458C541.864 547.871 543.215 547.324 544.224 546.346C545.234 545.367 545.823 544.034 545.867 542.629C546.076 535.347 546.435 527.882 546.435 525.332",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M213.331 519.681L222.201 576.387H559.343L568.213 518.92",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M229.232 576.821L233.621 589.127H240.217L245.049 576.387L229.232 576.821Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M538.05 576.821L542.439 589.127H549.035L553.867 576.387L538.05 576.821Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M244.012 522.164C241.12 523.688 237.955 524.623 234.699 524.914C228.285 525.332 221.881 523.963 216.198 520.96C211.751 518.652 205.33 515.693 205.932 509.691C206.534 503.688 210.948 497.36 214.735 492.837C218.778 487.909 223.781 483.855 229.441 480.924C236.329 477.488 244.806 475.206 251.695 478.065C255.684 479.831 259.314 482.316 262.404 485.396C266.174 489.025 271.04 494.693 269.577 500.377C268.214 505.669 261.994 509.298 257.948 512.433C253.601 515.785 249.028 519.622 244.012 522.164Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M536.102 522.164C538.994 523.687 542.16 524.621 545.415 524.914C551.834 525.333 558.244 523.964 563.932 520.96C568.372 518.652 574.8 515.693 574.19 509.691C573.58 503.688 569.174 497.36 565.387 492.837C561.345 487.909 556.341 483.855 550.682 480.924C543.793 477.488 535.316 475.206 528.428 478.065C524.439 479.842 520.811 482.339 517.727 485.43C513.956 489.058 509.091 494.726 510.554 500.411C511.917 505.703 518.136 509.331 522.191 512.466C526.521 515.785 531.078 519.622 536.102 522.164Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M545.415 524.914H455.796C455.796 524.914 453.171 525.65 453.171 518.41C453.171 518.41 452.987 524.872 448.322 524.872H339.266C339.266 524.872 337.468 525.056 337.644 520.918C337.82 516.78 337.468 524.153 336.206 524.872C334.944 525.591 235.777 524.872 235.777 524.872",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M391.984 626.02C412.147 626.02 428.492 619.283 428.492 610.972C428.492 602.662 412.147 595.924 391.984 595.924C371.821 595.924 355.476 602.662 355.476 610.972C355.476 619.283 371.821 626.02 391.984 626.02Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M366.427 341.22C366.427 341.22 365.199 335.418 361.152 335.418C357.106 335.418 356.044 339.891 358.594 344.999C361.144 350.107 368.392 353.309 368.818 350.324C369.245 347.34 366.427 341.22 366.427 341.22Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M429.771 318.08C429.771 318.08 431.535 323.973 429.771 329.566C428.816 332.744 427.32 335.734 425.349 338.403V321.616L429.771 318.08Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M376.1 594.904C376.1 594.904 369.73 604.786 363.669 609.568C357.608 614.349 358.569 616.573 363.033 617.535C367.498 618.496 374.186 617.217 378.332 613.07C380.811 610.6 382.956 607.814 384.711 604.786L384.544 607.093C384.541 607.147 384.555 607.201 384.583 607.248C384.611 607.294 384.652 607.331 384.701 607.354C384.75 607.378 384.805 607.386 384.859 607.378C384.913 607.37 384.963 607.347 385.003 607.31L389.81 602.871C390.797 600.211 390.909 597.306 390.128 594.578C388.857 589.805 381.208 589.161 376.1 594.904Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M368.384 615.922C362.741 616.223 360.45 614.994 359.556 614.191C358.987 615.93 360.392 616.967 363.042 617.535C367.506 618.488 374.194 617.217 378.34 613.071C380.82 610.6 382.964 607.815 384.719 604.786L384.552 607.093C384.55 607.148 384.563 607.201 384.591 607.248C384.619 607.294 384.661 607.332 384.71 607.355C384.759 607.378 384.814 607.386 384.867 607.378C384.921 607.371 384.971 607.347 385.012 607.311L389.819 602.872C390.463 601.18 390.731 599.369 390.605 597.563C388.757 599.344 385.589 602.42 383.39 604.61C380.129 607.904 376.652 615.487 368.384 615.922Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M409.741 594.904C409.741 594.904 416.119 604.786 422.172 609.568C428.225 614.349 427.272 616.573 422.816 617.535C418.36 618.496 411.655 617.217 407.509 613.07C405.033 610.598 402.891 607.813 401.138 604.786L401.297 607.093C401.299 607.147 401.286 607.201 401.258 607.247C401.23 607.294 401.188 607.331 401.139 607.354C401.09 607.378 401.035 607.386 400.982 607.378C400.928 607.37 400.878 607.347 400.837 607.31L396.039 602.888C395.046 600.229 394.935 597.322 395.721 594.595C397 589.804 404.641 589.161 409.741 594.904Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M417.323 616.139C409.925 613.965 406.882 609.175 404.708 606.349C402.793 603.841 396.674 599.118 395.228 597.989C395.173 599.651 395.457 601.307 396.064 602.855L400.862 607.294C400.903 607.33 400.953 607.354 401.007 607.362C401.06 607.369 401.115 607.361 401.164 607.338C401.214 607.315 401.255 607.278 401.283 607.231C401.311 607.185 401.324 607.131 401.322 607.077L401.163 604.769C402.916 607.797 405.058 610.582 407.534 613.054C411.714 617.234 418.402 618.471 422.841 617.518C425.666 616.908 427.071 615.788 426.185 613.84C425.091 615.043 423.671 615.902 422.097 616.31C420.523 616.718 418.864 616.659 417.323 616.139Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M392.82 467.331L357.599 463.895L358.235 465.801C358.235 465.801 362.415 502.459 365.884 519.99C369.353 537.521 371.945 544.853 371.945 544.853C371.795 548.616 372.223 552.38 373.216 556.013C374.813 561.113 375.13 573.569 376.401 579.923C377.672 586.277 377.045 589.805 377.045 589.805C377.045 589.805 373.533 593.625 373.851 594.578C374.056 595.305 374.163 596.055 374.169 596.81C374.169 596.81 376.083 601.91 381.183 601.91C386.282 601.91 390.747 597.772 390.747 597.772L392.017 492.051L392.853 491.993L393.648 492.051L394.927 597.772C394.927 597.772 399.391 601.91 404.491 601.91C409.59 601.91 411.496 596.81 411.496 596.81C411.502 596.055 411.612 595.304 411.822 594.578C412.14 593.625 408.629 589.805 408.629 589.805C408.629 589.805 407.993 586.293 409.272 579.923C410.552 573.553 410.861 561.113 412.458 556.013C413.447 552.38 413.873 548.616 413.72 544.853C413.72 544.853 416.27 537.521 419.781 519.99C423.292 502.459 427.43 465.784 427.43 465.784L428.066 463.878L392.82 467.331Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5082_4301",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 357,
    y: 463,
    width: 72,
    height: 139
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M392.82 467.331L357.599 463.895L358.235 465.801C358.235 465.801 362.415 502.459 365.884 519.99C369.353 537.521 371.945 544.853 371.945 544.853C371.795 548.616 372.223 552.38 373.216 556.013C374.813 561.113 375.13 573.569 376.401 579.923C377.672 586.277 377.045 589.805 377.045 589.805C377.045 589.805 373.533 593.625 373.851 594.578C374.056 595.305 374.163 596.055 374.169 596.81C374.169 596.81 376.083 601.91 381.183 601.91C386.282 601.91 390.747 597.772 390.747 597.772L392.017 492.051L392.853 491.993L393.648 492.051L394.927 597.772C394.927 597.772 399.391 601.91 404.491 601.91C409.59 601.91 411.496 596.81 411.496 596.81C411.502 596.055 411.612 595.304 411.822 594.578C412.14 593.625 408.629 589.805 408.629 589.805C408.629 589.805 407.993 586.293 409.272 579.923C410.552 573.553 410.861 561.113 412.458 556.013C413.447 552.38 413.873 548.616 413.72 544.853C413.72 544.853 416.27 537.521 419.781 519.99C423.292 502.459 427.43 465.784 427.43 465.784L428.066 463.878L392.82 467.331Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5082_4301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.002 560.252C403.705 567.625 398.246 576.345 393.539 581.888",
    stroke: "#7D7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.534 546.692C415.534 546.692 413.795 550.036 411.112 554.818",
    stroke: "#7D7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.263 553.798C419.263 553.798 411.137 576.471 393.205 587.305",
    stroke: "#7D7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.322 556.507C401.322 556.507 394.216 570.719 393.205 572.391",
    stroke: "#7D7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.815 545.681C367.815 545.681 378.683 566.321 393.205 568.353",
    stroke: "#7D7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.544 566.999C371.544 566.999 384.084 574.782 393.539 576.136",
    stroke: "#7D7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.46 593.45C387.263 594.479 390.248 594.921 393.23 594.746",
    stroke: "#7D7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.07 589.805C378.257 590.596 379.497 591.306 380.782 591.928",
    stroke: "#7D7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.079 585.608C387.176 587.754 389.902 589.178 392.862 589.671",
    stroke: "#7D7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.491 587.004C412.491 587.004 404.708 593.776 400.645 595.464",
    stroke: "#7D7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M392.82 467.331L357.599 463.895L358.235 465.801C358.235 465.801 362.415 502.459 365.884 519.99C369.353 537.521 371.945 544.853 371.945 544.853C371.795 548.616 372.223 552.38 373.216 556.013C374.813 561.113 375.13 573.569 376.401 579.923C377.672 586.277 377.045 589.805 377.045 589.805C377.045 589.805 373.533 593.625 373.851 594.578C374.056 595.305 374.163 596.055 374.169 596.81C374.169 596.81 376.083 601.91 381.183 601.91C386.282 601.91 390.747 597.772 390.747 597.772L392.017 492.051L392.853 491.993L393.648 492.051L394.927 597.772C394.927 597.772 399.391 601.91 404.491 601.91C409.59 601.91 411.496 596.81 411.496 596.81C411.502 596.055 411.612 595.304 411.822 594.578C412.14 593.625 408.629 589.805 408.629 589.805C408.629 589.805 407.993 586.293 409.272 579.923C410.552 573.553 410.861 561.113 412.458 556.013C413.447 552.38 413.873 548.616 413.72 544.853C413.72 544.853 416.27 537.521 419.781 519.99C423.292 502.459 427.43 465.784 427.43 465.784L428.066 463.878L392.82 467.331Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M419.146 359.345C419.146 359.345 403.838 356.469 394.601 356.469C385.363 356.469 370.357 361.568 370.357 361.568L380.28 469.964C380.28 469.964 386.015 472.472 396.214 472.472C406.413 472.472 415.977 467.69 415.977 467.69L419.146 359.345Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M396.933 398.62C407.991 398.62 416.955 389.783 416.955 378.882C416.955 367.981 407.991 359.144 396.933 359.144C385.875 359.144 376.911 367.981 376.911 378.882C376.911 389.783 385.875 398.62 396.933 398.62Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M396.933 393.788C405.285 393.788 412.056 387.114 412.056 378.882C412.056 370.65 405.285 363.976 396.933 363.976C388.581 363.976 381.81 370.65 381.81 378.882C381.81 387.114 388.581 393.788 396.933 393.788Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M372.438 366.058C372.438 366.058 370.691 402.257 394.676 408.794C418.661 415.332 429.127 379.141 426.076 368.24C423.025 357.338 381.158 351.252 372.438 366.058Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M396.933 384.542C407.211 384.542 415.542 377.868 415.542 369.636C415.542 361.404 407.211 354.73 396.933 354.73C386.655 354.73 378.324 361.404 378.324 369.636C378.324 377.868 386.655 384.542 396.933 384.542Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M448.832 404.439C448.832 404.439 515.068 426.609 523.361 413.467C527.834 406.37 509.609 394.607 498.098 390.77C486.586 386.933 454.626 371.826 454.626 371.826",
    fill: "#FE8225"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_5082_4301",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 448,
    y: 371,
    width: 77,
    height: 47
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M448.832 404.439C448.832 404.439 515.068 426.609 523.361 413.467C527.834 406.37 509.609 394.607 498.098 390.77C486.586 386.933 454.626 371.826 454.626 371.826",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_5082_4301)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M504.476 408.585C495.138 408.585 458.831 400.1 449.986 398.001L448.849 404.439C448.849 404.439 515.085 426.609 523.378 413.467C523.629 413.067 523.815 412.63 523.93 412.172C517.68 409.94 511.111 408.73 504.476 408.585Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.603 392.275L452.452 406.169L460.603 398.453",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M448.832 404.439C448.832 404.439 515.068 426.609 523.361 413.467C527.834 406.37 509.609 394.607 498.098 390.77C486.586 386.933 454.626 371.826 454.626 371.826",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M454.876 394.64L436.351 478.558L408.236 485.589L410.577 423.608L414.832 368.022L416.504 357.581C416.504 357.581 454.416 370.572 457.184 372.495C459.951 374.418 458.856 385.035 458.856 385.035",
    fill: "#FE8225"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_5082_4301",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 408,
    y: 357,
    width: 52,
    height: 129
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M454.876 394.64L436.351 478.558L408.236 485.589L410.577 423.608L414.832 368.022L416.504 357.581C416.504 357.581 454.416 370.572 457.184 372.495C459.951 374.418 458.856 385.035 458.856 385.035",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_5082_4301)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M452.477 405.508L421.98 463.451C421.98 463.451 428.291 439.768 427.899 437.009C427.673 435.404 417.867 441.231 409.716 446.414L408.236 485.589L436.351 478.558L452.477 405.508Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M422.373 360.448C422.373 360.448 432.246 367.546 431.059 383.338C429.872 399.13 426.319 396.764 426.319 396.764C426.319 396.764 428.693 400.308 426.319 400.71C423.944 401.111 419.631 393.604 418.795 395.577C417.959 397.55 413.269 399.916 413.269 399.916L414.807 368.039C414.807 368.039 416.061 359.612 422.373 360.448Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.059 371.993C431.059 371.993 434.403 380.353 432.38 392.275",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.812 384.784C434.812 384.784 436.351 388.086 431.059 401.32",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.868 434.392C441.868 434.392 429.738 457.984 416.73 467.907",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.313 446.74C427.313 446.74 425.767 449.39 418.736 454.916",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M454.876 394.64L436.351 478.558L408.236 485.589L410.577 423.608L414.832 368.022L416.504 357.581C416.504 357.581 454.416 370.572 457.184 372.495C459.951 374.418 458.856 385.035 458.856 385.035",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M420.157 356.945C421.577 359.797 422.378 362.916 422.506 366.099C422.506 370.789 422.715 382.293 423.777 387.618C424.839 392.943 428.25 399.113 427.188 398.904C426.126 398.695 424.847 395.919 422.08 392.726C419.313 389.532 418.46 384.416 416.964 385.486C415.467 386.556 412.708 395.71 412.708 395.71C412.708 395.71 413.135 376.541 413.77 369.301C414.406 362.061 415.902 352.473 420.157 356.945Z",
    fill: "#FE8225"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_5082_4301",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 412,
    y: 355,
    width: 16,
    height: 44
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M420.157 356.945C421.577 359.797 422.378 362.916 422.506 366.099C422.506 370.789 422.715 382.293 423.777 387.618C424.839 392.943 428.25 399.113 427.188 398.904C426.126 398.695 424.847 395.919 422.08 392.726C419.313 389.532 418.46 384.416 416.964 385.486C415.467 386.556 412.708 395.71 412.708 395.71C412.708 395.71 413.135 376.541 413.77 369.301C414.406 362.061 415.902 352.473 420.157 356.945Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_5082_4301)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M420.157 356.945C421.577 359.797 422.378 362.916 422.506 366.099C422.506 370.789 422.715 382.293 423.777 387.618C424.839 392.943 428.25 399.113 427.188 398.904C426.126 398.695 424.847 395.919 422.08 392.726C419.313 389.532 418.46 384.416 416.964 385.486C415.467 386.556 412.708 395.71 412.708 395.71C412.708 395.71 413.135 376.541 413.77 369.301C414.406 362.061 415.902 352.473 420.157 356.945Z",
    fill: "black"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M420.157 356.945C421.577 359.797 422.378 362.916 422.506 366.099C422.506 370.789 422.715 382.293 423.777 387.618C424.839 392.943 428.25 399.113 427.188 398.904C426.126 398.695 424.847 395.919 422.08 392.726C419.313 389.532 418.46 384.416 416.964 385.486C415.467 386.556 412.708 395.71 412.708 395.71C412.708 395.71 413.135 376.541 413.77 369.301C414.406 362.061 415.902 352.473 420.157 356.945Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M334.342 375.496C334.342 375.496 307.824 419.612 303.694 428.741C299.564 437.87 293.913 446.297 295.434 450.034C296.956 453.771 301.286 456.555 309.78 456.12C318.274 455.685 345.427 408.526 345.427 408.526L334.342 375.496Z",
    fill: "#FE8225"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_5082_4301",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 295,
    y: 375,
    width: 51,
    height: 82
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M334.342 375.496C334.342 375.496 307.824 419.612 303.694 428.741C299.564 437.87 293.913 446.297 295.434 450.034C296.956 453.771 301.286 456.555 309.78 456.12C318.274 455.685 345.427 408.526 345.427 408.526L334.342 375.496Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_5082_4301)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M323.282 442.903C331.132 432.311 339.692 418.199 343.454 411.854L339.082 400.292L313.4 447.66L323.282 442.903Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.287 395.142L341.757 415.206L329.409 405.291",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.563 431.508C309.563 431.508 317.923 435.688 321.467 443.639",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.836 430.864C316.836 430.864 320.59 435.278 321.91 440.127",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M334.342 375.496C334.342 375.496 307.824 419.612 303.694 428.741C299.564 437.87 293.913 446.297 295.434 450.034C296.956 453.771 301.286 456.555 309.78 456.12C318.274 455.685 345.427 408.526 345.427 408.526L334.342 375.496Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M337.51 394.64L356.036 478.558L384.142 485.589L381.802 423.608L377.546 368.022L375.874 357.581C375.874 357.581 337.937 370.572 335.136 372.495C332.335 374.418 333.464 385.035 333.464 385.035",
    fill: "#FE8225"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_5082_4301",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 333,
    y: 357,
    width: 52,
    height: 129
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M337.51 394.64L356.036 478.558L384.142 485.589L381.802 423.608L377.546 368.022L375.874 357.581C375.874 357.581 337.937 370.572 335.136 372.495C332.335 374.418 333.464 385.035 333.464 385.035",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_5082_4301)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M356.036 478.558L384.151 485.589L382.98 454.523L346.297 434.426L356.036 478.558Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.02 436.382C351.02 436.382 358.544 446.305 366.904 452.032",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M369.872 388.872C369.872 388.872 364.747 399.138 367.506 399.531C370.265 399.924 372.698 389.123 376.192 392.425L379.678 395.769L376.585 376.273C373.291 379.819 370.978 384.161 369.872 388.872Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.217 361.627C368.217 361.627 362.699 377.511 364.246 390.954",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.821 370.664C361.821 370.664 359.171 384.558 362.038 392.275",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M337.51 394.64L356.036 478.558L384.142 485.589L381.802 423.608L377.546 368.022L375.874 357.581C375.874 357.581 337.937 370.572 335.136 372.495C332.335 374.418 333.464 385.035 333.464 385.035",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M372.229 356.945C370.813 359.798 370.015 362.917 369.889 366.099C369.889 370.789 369.671 382.293 368.609 387.618C367.548 392.943 364.137 399.113 365.232 398.904C366.327 398.695 367.573 395.919 370.34 392.726C373.107 389.532 373.968 384.416 375.456 385.486C376.944 386.556 379.712 395.71 379.712 395.71C379.712 395.71 379.285 376.541 378.65 369.301C378.014 362.061 376.485 352.473 372.229 356.945Z",
    fill: "#FE8225"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_5082_4301",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 365,
    y: 355,
    width: 15,
    height: 44
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M372.229 356.945C370.813 359.798 370.015 362.917 369.889 366.099C369.889 370.789 369.671 382.293 368.609 387.618C367.548 392.943 364.137 399.113 365.232 398.904C366.327 398.695 367.573 395.919 370.34 392.726C373.107 389.532 373.968 384.416 375.456 385.486C376.944 386.556 379.712 395.71 379.712 395.71C379.712 395.71 379.285 376.541 378.65 369.301C378.014 362.061 376.485 352.473 372.229 356.945Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_5082_4301)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M373.742 366.058C373.742 366.058 371.193 374.535 373.308 380.01C375.423 385.486 379.411 393.529 379.411 393.529L378.575 369.285",
    fill: "black"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M372.229 356.945C370.813 359.798 370.015 362.917 369.889 366.099C369.889 370.789 369.671 382.293 368.609 387.618C367.548 392.943 364.137 399.113 365.232 398.904C366.327 398.695 367.573 395.919 370.34 392.726C373.107 389.532 373.968 384.416 375.456 385.486C376.944 386.556 379.712 395.71 379.712 395.71C379.712 395.71 379.285 376.541 378.65 369.301C378.014 362.061 376.485 352.473 372.229 356.945Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M365.876 326.03C365.876 326.03 365.876 344.288 368.233 354.889C370.591 365.489 375.297 374.317 387.369 379.325C399.441 384.332 413.87 377.853 420.057 370.196C426.243 362.538 425.65 341.053 425.65 336.338C425.65 331.623 425.942 316.608 425.942 316.608C425.942 316.608 423.585 309.544 413.277 302.764C402.969 295.984 392.67 292.732 379.712 300.699C366.754 308.666 365.876 326.03 365.876 326.03Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M407.45 345.166L414.096 344.957",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M402.467 361.894C402.467 361.894 403.446 358.4 408.612 357.564",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M397.276 345.785V350.358C397.846 350.801 398.31 351.368 398.633 352.014C398.955 352.661 399.129 353.372 399.14 354.094C399.349 356.795 396.908 358.224 394.601 356.469",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M397.276 345.785V350.358C397.846 350.801 398.31 351.368 398.633 352.014C398.955 352.661 399.129 353.372 399.14 354.094C399.349 356.795 396.908 358.224 394.601 356.469",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M383.072 343.185H382.37C381.816 343.185 381.284 342.965 380.892 342.573C380.5 342.181 380.28 341.649 380.28 341.095H385.162C385.162 341.649 384.942 342.181 384.55 342.573C384.158 342.965 383.627 343.185 383.072 343.185Z",
    fill: "#263238"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M378.182 340.953H387.394",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M378.182 342.658H387.394",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M411.68 340.81C411.68 342.357 411.028 343.602 410.217 343.602C409.406 343.602 408.754 342.357 408.754 340.81C408.754 339.264 409.406 338.026 410.217 338.026C411.028 338.026 411.68 339.272 411.68 340.81Z",
    fill: "#263238"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M400.77 332.668C400.77 332.668 406.305 329.474 420.149 331.389",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M390.546 330.962C388.825 328.192 386.448 325.888 383.625 324.254C380.802 322.619 377.621 321.705 374.361 321.591",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M435.071 297.748C431.243 289.798 417.699 277.433 403.855 276.848C392.017 276.338 387.971 280.794 387.01 282.09C386.491 281.714 378.549 276.238 365.098 282.926C365.017 282.97 364.952 283.039 364.915 283.124C364.877 283.209 364.869 283.303 364.891 283.393C364.913 283.483 364.964 283.563 365.036 283.621C365.109 283.678 365.198 283.71 365.291 283.712C365.354 283.714 365.418 283.7 365.474 283.67C375.381 278.712 382.286 280.685 385.104 281.998C383.298 281.689 380.038 281.571 375.297 283.026C367.64 285.384 359.413 293.334 357.34 307.17C355.267 321.006 361.754 332.785 364.112 335.142C366.469 337.5 366.762 342.507 366.762 342.507L366.168 327.192C366.168 327.192 365.876 326.013 369.412 323.664C372.321 321.716 385.054 308.758 389.417 304.277C390.203 308.457 392.343 316.65 397.669 322.184C397.749 322.264 397.857 322.309 397.97 322.31C398.024 322.311 398.078 322.302 398.128 322.282C398.179 322.262 398.224 322.231 398.262 322.193C398.301 322.155 398.332 322.109 398.353 322.059C398.374 322.009 398.385 321.955 398.385 321.9C398.385 321.846 398.374 321.792 398.353 321.741C398.332 321.691 398.301 321.646 398.262 321.608C392.82 315.939 390.797 307.396 390.128 303.542L390.897 302.756C390.897 302.756 394.425 312.47 400.319 317.478C406.213 322.485 413.862 326.607 425.934 322.778C438.006 318.949 442.42 313.356 442.42 313.356C442.42 313.356 438.9 305.715 435.071 297.748Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_5082_4301",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 356,
    y: 276,
    width: 87,
    height: 67
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M435.071 297.748C431.243 289.798 417.699 277.433 403.855 276.848C392.017 276.338 387.971 280.794 387.01 282.09C386.491 281.714 378.549 276.238 365.098 282.926C365.017 282.97 364.952 283.039 364.915 283.124C364.877 283.209 364.869 283.303 364.891 283.393C364.913 283.483 364.964 283.563 365.036 283.621C365.109 283.678 365.198 283.71 365.291 283.712C365.354 283.714 365.418 283.7 365.474 283.67C375.381 278.712 382.286 280.685 385.104 281.998C383.298 281.689 380.038 281.571 375.297 283.026C367.64 285.384 359.413 293.334 357.34 307.17C355.267 321.006 361.754 332.785 364.112 335.142C366.469 337.5 366.762 342.507 366.762 342.507L366.168 327.192C366.168 327.192 365.876 326.013 369.412 323.664C372.321 321.716 385.054 308.758 389.417 304.277C390.203 308.457 392.343 316.65 397.669 322.184C397.749 322.264 397.857 322.309 397.97 322.31C398.024 322.311 398.078 322.302 398.128 322.282C398.179 322.262 398.224 322.231 398.262 322.193C398.301 322.155 398.332 322.109 398.353 322.059C398.374 322.009 398.385 321.955 398.385 321.9C398.385 321.846 398.374 321.792 398.353 321.741C398.332 321.691 398.301 321.646 398.262 321.608C392.82 315.939 390.797 307.396 390.128 303.542L390.897 302.756C390.897 302.756 394.425 312.47 400.319 317.478C406.213 322.485 413.862 326.607 425.934 322.778C438.006 318.949 442.42 313.356 442.42 313.356C442.42 313.356 438.9 305.715 435.071 297.748Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_5082_4301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.42 312.462C441.383 315.22 445.07 311.124 445.07 311.124",
    stroke: "#7D7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.984 290.642C391.984 290.642 398.304 304.854 413.402 310.497",
    stroke: "#7D7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.566 285.626C391.566 285.626 415.81 296.895 425.424 297.33C435.038 297.765 436.292 295.658 436.292 295.658",
    stroke: "#7D7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.968 291.478C386.968 291.478 368.994 301.092 363.978 311.96C358.962 322.828 361.052 330.352 361.052 330.352",
    stroke: "#7D7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.953 294.304C362.751 295.211 361.632 296.224 360.609 297.33",
    stroke: "#7D7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.296 288.134C378.967 287.844 372.677 289.265 367.088 292.247",
    stroke: "#7D7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M392.937 337.316C388.884 335.499 384.492 334.559 380.05 334.559C375.608 334.559 371.216 335.499 367.163 337.316C367.163 337.316 364.714 337.558 364.714 339.523C364.714 341.487 366.427 341.237 366.427 341.237C366.427 341.237 366.762 350.525 370.607 353.267C374.043 355.724 381.659 356.46 385.58 354.989C389.501 353.517 391.967 350.809 392.703 348.359C393.439 345.91 392.937 337.316 392.937 337.316Z",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M398.747 337.316C402.799 335.499 407.189 334.56 411.63 334.56C416.071 334.56 420.461 335.499 424.513 337.316C424.513 337.316 426.971 337.558 426.971 339.523C426.971 341.488 425.257 341.22 425.257 341.22C425.257 341.22 424.922 350.508 421.077 353.25C417.641 355.708 410.033 356.444 406.104 354.972C402.175 353.501 399.725 350.792 398.99 348.343C398.254 345.893 398.747 337.316 398.747 337.316Z",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M392.937 337.316C394.815 336.561 396.911 336.561 398.789 337.316",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M393.673 340.994H397.844",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M423.752 341.22C423.752 341.22 424.989 335.418 429.036 335.418C433.082 335.418 434.143 339.891 431.585 344.999C429.027 350.107 421.787 353.309 421.369 350.324C420.951 347.34 423.752 341.22 423.752 341.22Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M441.024 332.45C441.024 332.45 429.947 332.668 423.342 332.024C416.738 331.38 421.67 337.04 424.513 337.316C427.941 337.73 431.395 337.884 434.846 337.776C437.391 337.68 439.927 338.115 442.294 339.055C442.294 339.055 445.923 335.009 441.024 332.45Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M434.202 352.924C432.081 350.348 430.227 347.564 428.668 344.614C426.536 340.359 425.901 338.444 429.947 338.862C433.993 339.28 435.698 343.126 436.76 346.319C437.822 349.513 440.38 349.513 440.38 349.513L444 339.08L451.248 345.467L444.652 367.805C444.652 367.805 435.707 363.332 434.428 361.418C433.149 359.503 434.419 354.596 434.202 352.924Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M454.224 339.264C454.224 339.264 453.589 335.861 450.604 335.217C447.62 334.574 442.512 330.962 440.806 331.598C439.101 332.233 435.907 342.466 435.907 344.138C435.907 345.81 437.822 347.548 438.466 347.548C439.109 347.548 444.652 337.776 444.652 337.776L454.224 339.264Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M454.442 341.822C454.442 341.822 455.503 339.481 454.442 338.419C453.38 337.358 446.558 335.217 444.217 334.791C441.877 334.365 441.45 335.217 440.171 338.419C438.892 341.621 436.125 346.085 437.404 347.147C438.683 348.209 440.38 349.488 440.38 349.488L444.853 340.334L454.442 341.822Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M444 352.264C444 352.264 439.745 350.592 439.101 349.279C438.457 347.967 442.721 337.35 443.365 337.141C444.008 336.932 446.767 337.776 447.62 338.202C448.473 338.629 455.077 339.69 455.503 342.466C455.93 345.241 451.457 360.992 451.883 362.697C452.31 364.403 455.721 366.317 455.721 366.317L450.604 375.045C450.604 375.045 442.512 368.022 439.527 366.526C436.543 365.03 440.597 360.139 441.659 357.581C442.721 355.023 444 352.264 444 352.264Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M444 352.263L446.984 346.721",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M444.853 346.512L448.899 346.938",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M454.442 364.402L445.923 373.13L454.015 380.37L461.89 368.658L454.442 364.402Z",
    fill: "#FE8225",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M506.658 414.429C504.986 414.002 470.627 396.346 466.58 393.788C462.534 391.23 452.945 385.486 452.945 382.502C452.945 379.517 461.255 367.379 461.255 367.379C461.255 367.379 463.387 364.185 466.789 366.1C470.192 368.014 501.977 388.229 510.069 392.492C518.161 396.756 524.34 399.949 524.766 408.251C525.192 416.552 518.161 418.049 513.48 417.447",
    fill: "#FE8225"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_5082_4301",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 452,
    y: 365,
    width: 73,
    height: 53
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M506.658 414.429C504.986 414.002 470.627 396.346 466.58 393.788C462.534 391.23 452.945 385.486 452.945 382.502C452.945 379.517 461.255 367.379 461.255 367.379C461.255 367.379 463.387 364.185 466.789 366.1C470.192 368.014 501.977 388.229 510.069 392.492C518.161 396.756 524.34 399.949 524.766 408.251C525.192 416.552 518.161 418.049 513.48 417.447",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_5082_4301)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M499.569 401.897C488.124 399.673 468.06 393.278 463.312 391.731C464.557 392.567 465.702 393.236 466.58 393.788C470.627 396.346 504.953 414.002 506.658 414.429L513.48 417.413C518.161 418.049 525.184 416.577 524.766 408.217C524.348 399.857 518.161 396.714 510.069 392.459C505.27 389.951 492.128 381.791 481.528 375.187C494.118 384.149 512.142 397.341 512.61 399.69C513.338 403.343 512.61 404.43 499.569 401.897Z",
    fill: "black"
  }))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M506.658 414.429C504.986 414.002 470.627 396.346 466.58 393.788C462.534 391.23 452.945 385.486 452.945 382.502C452.945 379.517 461.255 367.379 461.255 367.379C461.255 367.379 463.387 364.185 466.789 366.1C470.192 368.014 501.977 388.229 510.069 392.492C518.161 396.756 524.34 399.949 524.766 408.251C525.192 416.552 518.161 418.049 513.48 417.447",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M441.659 408.275L419.087 412.748L419.94 418.709L432.505 421.049L440.806 413.601L441.659 408.275Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M310.892 440.445C312.46 440.112 314.081 440.111 315.649 440.444C317.217 440.777 318.698 441.435 319.996 442.376C324.778 445.636 336.515 452.408 346.297 455.852C356.078 459.297 357.591 459.547 356.329 465.634C355.066 471.72 350.677 480.414 346.556 481.518C342.434 482.621 333.949 476.301 320.907 469.345C307.866 462.39 296.128 458.26 294.824 453.043C293.52 447.827 299.171 438.923 299.171 438.923",
    fill: "#FE8225"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_5082_4301",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 294,
    y: 438,
    width: 63,
    height: 44
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M310.892 440.445C312.46 440.112 314.081 440.111 315.649 440.444C317.217 440.777 318.698 441.435 319.996 442.376C324.778 445.636 336.515 452.408 346.297 455.852C356.078 459.297 357.591 459.547 356.329 465.634C355.066 471.72 350.677 480.414 346.556 481.518C342.434 482.621 333.949 476.301 320.907 469.345C307.866 462.39 296.128 458.26 294.824 453.043C293.52 447.827 299.171 438.923 299.171 438.923",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_5082_4301)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M346.297 455.877L345.16 455.459L352.508 459.899C352.508 459.899 344.215 459.899 343.036 466.219C341.857 472.539 345.795 476.084 343.429 476.869C341.063 477.655 309.479 462.657 309.479 462.657L310.507 464.129C313.734 465.709 317.246 467.414 320.865 469.345C333.907 476.301 342.384 482.604 346.514 481.518C350.644 480.431 354.983 471.736 356.287 465.634C357.591 459.531 356.036 459.355 346.297 455.877Z",
    fill: "black"
  }))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M310.892 440.445C312.46 440.112 314.081 440.111 315.649 440.444C317.217 440.777 318.698 441.435 319.996 442.376C324.778 445.636 336.515 452.408 346.297 455.852C356.078 459.297 357.591 459.547 356.329 465.634C355.066 471.72 350.677 480.414 346.556 481.518C342.434 482.621 333.949 476.301 320.907 469.345C307.866 462.39 296.128 458.26 294.824 453.043C293.52 447.827 299.171 438.923 299.171 438.923",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M404.106 461.964C404.106 461.964 408.662 462.8 411.923 461.964C415.183 461.128 415.4 462.8 413.879 465.659C412.357 468.518 408.662 469.789 406.28 469.571C403.897 469.354 400.194 464.355 404.106 461.964Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M363.677 470.006C363.677 470.006 369.328 468.702 371.502 467.18C373.676 465.659 390.847 454.139 393.021 454.139C395.194 454.139 409.741 465.441 409.966 466.311C410.192 467.18 405.845 472.614 404.541 473.701C403.237 474.788 398.02 481.309 396.716 482.613C395.412 483.917 390.412 486.308 388.891 486.743C387.369 487.177 385.196 485.907 385.63 484.352C386.065 482.797 386.466 481.526 386.466 481.526C386.466 481.526 378.207 485.656 373.86 484.569C369.512 483.482 359.296 478.266 359.296 478.266L363.677 470.006Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M386.5 470.875C386.5 470.875 396.933 480.005 396.716 482.579L386.5 470.875Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M386.5 470.875C386.5 470.875 396.933 480.005 396.716 482.579",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M389.326 463.703L401.498 476.527",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M393.455 457.616L406.062 471.527",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M386.5 481.526C386.5 481.526 390.195 480.222 389.76 482.362L386.5 481.526Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M386.5 481.526C386.5 481.526 390.195 480.222 389.76 482.362",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M353.461 463.92L365.165 468.702L359.079 482.396L347.375 476.744C347.375 476.744 346.949 468.484 353.461 463.92Z",
    fill: "#FE8225",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleImgDark);
export default __webpack_public_path__ + "static/media/role_img_dark.3c0cada2398748eb499a3f58bb617adf.svg";
export { ForwardRef as ReactComponent };